import React, { Component } from "react";
import FileDetails from "./FileDetails";

class ChapterResults extends Component {
  render() {
    return (
      <div>
        {this.props.results.map((file, index) => {
          return (
            <div>
              <FileDetails
                file={file}
                key={"FileDetails" + index}
                index={index}
                name={this.props.chapterName}
              />
            </div>
          );
        })}
      </div>
    );
  }
}

export default ChapterResults;
